import { render, staticRenderFns } from "./InstallersOverviewTable.vue?vue&type=template&id=4cfd801e&scoped=true"
import script from "./InstallersOverviewTable.vue?vue&type=script&lang=js"
export * from "./InstallersOverviewTable.vue?vue&type=script&lang=js"
import style0 from "./InstallersOverviewTable.vue?vue&type=style&index=0&id=4cfd801e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd801e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField,VTooltip})
